'use client';
import IconAppGallery from '@/assets/icons/main-page/icon-app-gallery.svg';
import IconAppStore from '@/assets/icons/main-page/icon-app-store.svg';
import IconPlayMarket from '@/assets/icons/main-page/icon-play-market.svg';
import ImageThumbnailsMobile from '@/assets/images/main-page/image-thumbnails-mobile.png';
import ImageThumbnails from '@/assets/images/main-page/image-thumbnails.png';
import { Link, usePathname } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import styles from './thumb.module.scss';
type Props = {};

const Thumbnails = (props: Props) => {
  const pathname = usePathname();
  const t = useTranslations('General');
  return (
    <div
      className={styles.thumbWrapper}
      style={{
        backgroundColor:
          pathname === '/news' ||
          pathname === '/about-company' ||
          pathname === '/catalog/category/smartphones/xiaomi'
            ? '#f3f4f6'
            : '#ffffff',
      }}
    >
      <div className={styles.contents}>
        <div className={styles.leftSide}>
          <Image
            className={styles.image}
            src={ImageThumbnails}
            alt={'thumbnails'}
          />
          <Image
            className={styles.imageMobile}
            src={ImageThumbnailsMobile}
            alt={'thumbnails'}
          />
          <h4>{t('app-download')}</h4>
        </div>
        <div className={styles.markets}>
          <Link href={'#'} className={styles.market}>
            <IconPlayMarket />
            <p>Google Play</p>
          </Link>
          <Link href={'#'} className={styles.market}>
            <IconAppStore />
            <p>App Store</p>
          </Link>
          <Link href={'#'} className={styles.market}>
            <IconAppGallery />
            <p>App Gallery</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Thumbnails;
